import React from 'react';
export var DynamicFormContext = /*#__PURE__*/React.createContext({});
export var DynamicFormContextProvider = DynamicFormContext.Provider;
export var DynamicFormContextConsumer = DynamicFormContext.Consumer;